"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

var _reactRedux = require("react-redux");

var _timezones = require("../../../Shared/store/timezones");

var _timezones2 = require("../../../Shared/store/timezones/timezones.helpers");

var _userTrackGiftSchedule = require("./userTrackGiftSchedule");

var _CustomScheduleForm = _interopRequireDefault(require("./CustomScheduleForm"));

var DEFAULT_TIMEZONE_NAME = _timezones.Timezones.CONSTANTS.DEFAULT_TIMEZONE_NAME;
var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var zIndex = _ref.zIndex,
      spacing = _ref.spacing;
  return {
    popper: {
      zIndex: zIndex.modal,
      width: 540
    },
    paper: {
      position: 'relative',
      '&:after': {
        width: 0,
        height: 0,
        margin: 'auto',
        content: '""',
        display: 'block',
        borderStyle: 'solid',
        borderColor: "#fff #0000 #0000 #0000",
        borderWidth: '12px 12px 0 12px',
        position: 'absolute',
        right: 36,
        bottom: "-12px"
      }
    },
    submitButton: {
      padding: spacing(5 / 8, 12 / 8)
    }
  };
});

var CustomSchedule = function CustomSchedule(_ref2) {
  var _ref2$anchorEl = _ref2.anchorEl,
      anchorEl = _ref2$anchorEl === void 0 ? null : _ref2$anchorEl,
      _ref2$open = _ref2.open,
      open = _ref2$open === void 0 ? false : _ref2$open,
      onSchedule = _ref2.onSchedule,
      onClose = _ref2.onClose;
  var classes = useStyles();
  var trackGiftScheduled = (0, _userTrackGiftSchedule.useTrackGiftScheduled)();
  var timezones = (0, _reactRedux.useSelector)(_timezones.Timezones.selectors.getTimezones);
  var handleFormSubmit = (0, _react.useCallback)(function (form) {
    var timezone = timezones.find(function (tz) {
      return (0, _timezones2.formatTimezoneTitle)(tz) === form.tz;
    });
    var tz = (timezone === null || timezone === void 0 ? void 0 : timezone.name) || DEFAULT_TIMEZONE_NAME;

    var _moment$toArray = (0, _momentTimezone.default)(form.date).toArray(),
        _moment$toArray2 = (0, _slicedToArray2.default)(_moment$toArray, 3),
        year = _moment$toArray2[0],
        month = _moment$toArray2[1],
        day = _moment$toArray2[2];

    var date = _momentTimezone.default.tz("".concat(year, " ").concat(month + 1, " ").concat(day, " ").concat(form.hh, ":").concat(form.mm, " ").concat(form.interval), 'YYYY M D h:m A', tz);

    onSchedule(date.format());
    trackGiftScheduled('custom', date);
  }, [onSchedule, trackGiftScheduled, timezones]);
  return /*#__PURE__*/_react.default.createElement(_material.Popper, {
    className: classes.popper,
    open: open,
    anchorEl: anchorEl,
    placement: "top-end",
    modifiers: [{
      name: 'flip',
      enabled: true
    }, {
      name: 'preventOverflow',
      enabled: true,
      options: {
        altBoundary: true
      }
    }, {
      name: 'offset',
      options: {
        offset: '16px,4px'
      }
    }],
    role: undefined,
    transition: true,
    disablePortal: true
  }, function (_ref3) {
    var TransitionProps = _ref3.TransitionProps;
    return /*#__PURE__*/_react.default.createElement(_material.Zoom, (0, _extends2.default)({}, TransitionProps, {
      style: {
        transformOrigin: 'right bottom'
      },
      mountOnEnter: true,
      unmountOnExit: true
    }), /*#__PURE__*/_react.default.createElement(_material.Paper, {
      className: classes.paper
    }, /*#__PURE__*/_react.default.createElement(_CustomScheduleForm.default, {
      onSubmit: handleFormSubmit,
      onClose: onClose
    })));
  });
};

var _default = /*#__PURE__*/(0, _react.memo)(CustomSchedule);

exports.default = _default;